<template>
  <div id="app">
    <my-header
        :header="header"
        :userInfo="userInfo"
        @login="initUserInfo"
        @logout="logout"
    ></my-header>
    <keep-alive>
      <router-view
          :ref="$route.fullPath"
          @login="initUserInfo"
      ></router-view>
    </keep-alive>
    <el-backtop></el-backtop>
    <my-footer></my-footer>
  </div>
</template>

<script>
import {EventBus} from "@/plugins/eventBus";

export default {
  name: 'app',
  data() {
    return {
      header: '',
      userInfo: {}
    }
  },
  mounted() {
    this.initUserInfo()
    this.validateTime()
  },
  watch: {
    $route(val) {
      this.initUserInfo()
      this.validateTime()
      scrollTo(0,0)
      if (val.path.indexOf('sub-index') !== -1) {
        this.header = val.params.type
      } else if (val.path === '/') {
        this.header = '首页'
      } else if (val.path.indexOf('article-page') !== -1 || val.path.indexOf('article-vip') !==-1) {
        EventBus.$on('header', header => {
          this.header = header
        })
      } else {
        this.header = '首页'
      }
    }
  },
  methods: {
    logout() {
      this.initUserInfo()
      if(this.$route.path === '/other/experts' || this.$route.path === '/other/certificate') {
        this.$refs[this.$route.path].$refs[this.$route.path].isLogin = false
      }
    },
    initUserInfo() {
      var userInfo = localStorage.getItem('userInfo')
      if(userInfo) {
        this.userInfo = Object.assign({}, JSON.parse(userInfo))
      }else{
        this.userInfo = {}
      }
    },
    validateTime() {
      var time = Number(localStorage.getItem('loginTime'))
      if(time) {
        var nowTime = new Date().getTime()
        if(nowTime - time > 24 * 60 * 1000) {
          localStorage.removeItem('loginTime')
          localStorage.removeItem('userInfo')
        }else{
          localStorage.setItem('loginTime', nowTime)
        }
      }else{
        localStorage.removeItem('loginTime')
        localStorage.removeItem('userInfo')
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  background: rgb(238, 238, 238);
  min-width: fit-content;
}

.my-divider {
  background: #DCDFE6;
  height: 1px;
  width: 100%;
  margin-top: 10px;
}

.center-part {
  width: 1400px;
  margin: 0 auto;
}

.xh-tabs {

}

.xh-tab-header {
  overflow: hidden;
  border-bottom: 1px solid #114cbd;
}

.xh-tab-pane {
  background-color: #fff;
  float: left;
  border: none;
  outline: none;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  width: 80px;
  font-weight: bold;
  cursor: pointer;
  padding: 10px;
  transition: 0.3s;
  color: #0e3d97;
  text-align: center;
}

.xh-tab-pane:hover {
  background-color: rgba(220, 238, 255, 0.82);

}

.xh-tab-pane.active {
  background-color: #0e3d97;
  color: white;
}

.my-button {
  background: #0e3d97;
  color: #fff;
  padding: 10px;
  width: fit-content;
  font-family: 微软雅黑;
  cursor: pointer;
  margin-left: 10px;
}

.my-button:hover {
  background: rgba(14, 61, 151, 0.65);
}

.row-tabs {
  width: 100px;
  background: #f7f7f7;
  height: 100%;
  /*background: #1e50ae;*/
  transition: 0.3s;
  display: inline-flex;
  vertical-align: top;
  flex-direction: column;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.1);
}

.row-tab-pane {
  flex: 1;
  color: #0e3d97;
  font-weight: bold;
  cursor: pointer;
  padding: 10px;
  margin: auto 0;
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 18px;
  border-bottom: 1px solid rgba(14, 61, 151, 0.09);
}

.row-tab-pane:hover {
  /*color: #fff;*/
  /*background: rgba(14, 61, 151, 0.43);*/
  background-color: rgba(220, 238, 255, 0.82);
}

.row-tab-pane.active {
  color: #fff;
  background: #0e3d97;
  transform: scale(1.1);
}

.row-tab-pane.hidden {
  visibility: hidden;
}

.ql-editor {
  height: auto !important;
  line-height: 2.0 !important;
}

::v-deep .ql-editor a {
  text-decoration: underline #1482f0;
  color: #1482f0 !important;
}

::v-deep .ql-editor a:hover {
  color: #00afff !important;
  text-decoration: underline #00afff;
}
</style>
